import axios from 'axios'
// var http = 'http://admin.chinawtf.org'
// var httpUser = 'https://h5.daoba.com/'
// var http2 = 'https://mechanism.daoba.com'
// var http2 = 'http://192.168.2.128:10001'
// var http = 'http://www.daoba.com.ngrok2.xiaomiqiu.cn'
// var http = 'http://192.168.2.128:10003'
// var http = 'http://192.168.2.176:10001/'
var http = 'https://card.matchn.cn'

/**
 * 获取协会ID
 * @param {*} parameter
 */
export function findAssoIdByDomainName (parameter) {
  return axios({
    url: http + '/user/domain/findAssoIdByDomainName',
    method: 'get',
    params: parameter
  })
}
/**
 * 协会官网配置信息
 * @param {*} parameter
 */
export function findAssoAbout (parameter) {
  return axios({
    url: http + '/user/assoAbout/findAssoAbout/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 名师列表
 * @param {*} parameter
 */
export function websitePageQuery (parameter) {
  return axios({
    url: http + '/user/teachers/websitePageQuery/' + parameter.assoId + '/' + parameter.pageNo + '/' + parameter.pageSize,
    method: 'get'
    // params: parameter
  })
}
/**
 * 新闻详情
 * @param {*} parameter
 */
export function getDetailContent (parameter) {
  return axios({
    url: http + '/user/teachers/getDetailContent/' + parameter.id,
    method: 'get'
    // params: parameter
  })
}
/**
 * 首页新闻列表
 * @param {*} parameter
 */
export function websitePageNews (parameter) {
  return axios({
    url: http + '/user/news/websitePageNews/' + parameter.pageNo + '/' + parameter.pageSize + '/' + parameter.assoId + '/' + parameter.type,
    method: 'get'
    // params: parameter
  })
}
/**
 * 新闻详情
 * @param {*} parameter
 */
export function websiteNewsDetail (parameter) {
  return axios({
    url: http + '/user/news/websiteNewsDetail/' + parameter.newsId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 精彩图集
 * @param {*} parameter
 */
export function pageQuery (parameter) {
  return axios({
    url: http + '/user/excitionImgs/pageQuery/' + parameter.pageNo + '/' + parameter.pageSize + '/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 活动信息
 * @param {*} parameter
 */
export function websitePageQueryList (parameter) {
  return axios({
    url: http + '/user/eventNews/websitePageQueryList/' + parameter.pageNo + '/' + parameter.pageSize + '/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 活动流量数量
 * @param {*} parameter
 */
export function addView (parameter) {
  return axios({
    url: http + '/user/eventNews/addView/' + parameter.id,
    method: 'put'
    // params: parameter
  })
}
/**
 * 首页banner
 * @param {*} parameter
 */
export function websiteBannerList (parameter) {
  return axios({
    url: http + '/user/mainBanner/websiteBannerList/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 精彩图集详情
 * @param {*} parameter
 */
export function findDetail (parameter) {
  return axios({
    url: http + '/user/excitionImgs/findDetail/' + parameter.id,
    method: 'get'
    // params: parameter
  })
}

/**
 * 协会简介
 * @param {*} parameter
 */
export function queryAssoDesc (parameter) {
  return axios({
    url: http + '/user/assoDesc/queryAssoDesc/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 个人证书查询
 * @param {*} parameter
 */
export function findUserCertDetail (parameter) {
  return axios({
    url: http + '/user/certUser/findUserCertDetail/' + parameter.certNo + '/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 根据项目Id查询证书
 * @param {*} parameter
 */
export function findUserCertDetailByProject (parameter) {
  return axios({
    url: http + '/user/certUser/findUserCertDetailByProject/' + parameter.certNo + '/' + parameter.assoId + '/' + parameter.projectId,
    method: 'get'
    // params: parameter
  })
}

/**
 * 会员登录
 * @param {*} parameter
 */
export function memberLogin (parameter) {
  return axios({
    url: http + '/user/associationCode/memberLogin/' + parameter.phoneNo + '/' + parameter.pwd + '/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 修改密码
 * @param {*} parameter
 */
export function modifiedPwd (parameter) {
  return axios({
    url: http + '/user/associationCode/modifiedPwd/',
    method: 'PUT',
    data: parameter
  })
}
/**
 * 查询协会下的所有项目
 * @param {*} parameter
 */
export function queryAllProject (parameter) {
  return axios({
    url: http + '/user/certificate/queryAllProject/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 会员登录
 * @param {*} parameter
 */
export function certificatePageQuery (parameter) {
  return axios({
    url: http + '/user/certificate/pageQuery/' + parameter.pageNo + '/' + parameter.pageSize + '/' + parameter.projectId + '/' + parameter.memberId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 是否有免责声明
 * @param {*} parameter
 */
export function disclaimerExits (assoId) {
  return axios({
    url: http + '/user/memberOrder/disclaimerExits/' + assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 获取免责声明
 * @param {*} parameter
 */
export function getDisclaimerByAssoId (assoId) {
  return axios({
    url: http + '/user/memberOrder/getDisclaimerByAssoId/' + assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 验证账号是否可用
 * @param {*} parameter
 */
export function checkAccount (parameter) {
  return axios({
    url: http + '/user/memberOrder/checkAccount/' + parameter.phoneNo + '/' + parameter.assoId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 根据会员类型获取申请会员所需的资料
 * @param {*} parameter
 */
export function queryApplyVerifyData (parameter) {
  return axios({
    url: http + '/user/verifyData/queryApplyVerifyData/' + parameter.assoId + '/' + parameter.memberTypeId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 会员申请，创建订单获取支付链接
 * @param {*} parameter
 */
export function memberApply (parameter) {
  return axios({
    url: http + '/user/memberOrder/memberApply/',
    method: 'post',
    data: parameter
  })
}
/**
 * 会员申请，创建订单获取支付链接
 * @param {*} parameter
 */
export function queryMemberOrderStatus (orderNo) {
  return axios({
    url: http + '/user/memberOrder/queryOrderStatus/' + orderNo,
    method: 'get'
    // data: parameter
  })
}
/**
 *  获取已经上传的资料和驳回原因
 * @param {*} parameter
 */
export function queryBackData (memberId) {
  return axios({
    url: http + '/user/associationCode/queryBackData/' + memberId,
    method: 'get'
    // data: parameter
  })
}
/**
 * 重新上传审核资料
 * @param {*} parameter
 */
export function reloadVerifyData (parameter) {
  return axios({
    url: http + '/user/associationCode/reloadVerifyData',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取会员类型
 * @param {*} parameter
 */
export function queryMemberType (assoId) {
  return axios({
    url: http + '/user/memberType/queryMemberType/' + assoId,
    method: 'get'
    // params: parameter
  })
}

/**
 * 购买证书号
 * @param {*} parameter
 */
export function createBuyOrder (parameter) {
  return axios({
    url: http + '/user/memberCert/createBuyOrder/',
    method: 'post',
    data: parameter
  })
}
/**
 * 查询证书订单状态
 * @param {*} parameter
 */
export function queryOrderStatus (orderNo) {
  return axios({
    url: http + '/user/memberCert/queryOrderStatus/' + orderNo,
    method: 'get'
    // params: parameter
  })
}
/**
 * 会员登录
 * @param {*} parameter
 */
export function memberPageQuery (parameter, keyWords) {
  return axios({
    url: http + '/user/memberTeamUser/pageQuery/' + parameter.memberId + '/' + parameter.pageNo + '/' + parameter.pageSize + '?keyWords=' + keyWords,
    method: 'get'
    // params: keyWords
  })
}
/**
 * 添加成员
 * @param {*} parameter
 */
export function addMemberTeamUser (parameter) {
  return axios({
    url: http + '/user/memberTeamUser/addMemberTeamUser/',
    method: 'post',
    data: parameter
  })
}
/**
 * 修改成员信息
 * @param {*} parameter
 */
export function updateMemberTeamUser (parameter) {
  return axios({
    url: http + '/user/memberTeamUser/updateMemberTeamUser/',
    method: 'PUT',
    data: parameter
  })
}
/**
 * 删除成员信息
 * @param {*} parameter
 */
export function delMemberTeamUser (value) {
  return axios({
    url: http + '/user/memberTeamUser/delMemberTeamUser/' + value.id + '/' + value.memberId,
    method: 'DELETE'
    // data: parameter
  })
}
/**
 * 给团体会员下属成员添加证书号
 * @param {*} parameter
 */
export function websiteAddCertUser (parameter) {
  return axios({
    url: http + '/user/certificate/websiteAddCertUser/',
    method: 'post',
    data: parameter
  })
}
/**
 * 通过项目id查询证书类型
 * @param {*} parameter
 */
export function queryCertTypeByProjectId (parameter) {
  return axios({
    url: http + '/user/certificate/queryCertTypeByProjectId/' + parameter.assoId + '/' + parameter.projectId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 通过项目id证书
 * @param {*} parameter
 */
export function pageQueryMemberTeamUserCert (value, parameter) {
  return axios({
    url: http + '/user/certificate/pageQueryMemberTeamUserCert/' + value.memberId + '/' + value.pageNo + '/' + value.pageSize,
    method: 'get',
    params: parameter
  })
}
/**
 * 查询模板信息
 * @param {*} parameter
 */
export function findById (parameter) {
  return axios({
    url: http + '/user/memberTeamUser/findById/' + parameter.memberId + '/' + parameter.certId,
    method: 'get'
    // params: parameter
  })
}
/**
 * 查询模板信息
 * @param {*} parameter
 */
export function saveTemplate (parameter) {
  return axios({
    url: http + '/user/memberTeamUser/saveTemplate/',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取主赛事模板
 * @param {*} parameter
 */

/**
 * 分享
 * @param {*} parameter
 */
// createExtensionOrder
export function getSharedClubData (parameter) {
  return axios({
    url: http + '/user/WeShare/getSharedClubData',
    method: 'post',
    data: parameter
  })
}



// WEBPACK FOOTER //
// ./src/api/association.js